
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import moment from 'moment';

  import { IErrorModel } from '@/models/errors.model';

  @Component
  export default class Input extends Vue {
    @Prop()
    public Label!: string;

    @Prop()
    public Name!: string;

    @Prop()
    public Value!: string;

    @Prop({ default: false, type: Boolean })
    public IsPassword!: boolean;

    @Prop({ default: false, type: Boolean })
    public IsDate!: boolean;

    @Prop({ default: false, type: Boolean })
    public IsReadOnly!: boolean;

    @Prop({ default: false, type: Boolean })
    public PreventCopyPasting!: boolean;

    @Prop({ default: false, type: Boolean })
    public IsOptional!: boolean;

    @Prop({ default: false, type: Boolean })
    public FocusInput!: boolean;

    @Prop({ default: '', type: String })
    public Condition!: string;

    @Prop({ default: null, type: String })
    public Placeholder!: string;

    @Prop({ default: true, type: Boolean })
    public HasTabIndex!: boolean;

    @Prop()
    public Errors!: Array<IErrorModel>;

    data() {
      return {
        isFocused: false,
        isLabeled: false,
        hasErrors: false,
        inputValue: '',
        errors: new Array < IErrorModel > ()
      }
    };

    created() {
      this.$data.errors = this.Errors;
      this.$watch(() => this.Errors, (params) => {
        this.$data.errors = this.Errors;
      });
    }

    beforeMount() {
      this.$data.inputValue = this.Value;
      this.$data.errors = this.Errors;
      this.$data.isLabeled = this.$data.inputValue != null && this.$data.inputValue != "";
    }

    mounted() {
      if (this.IsPassword && this.FocusInput) {
        (this.$refs.password as HTMLInputElement).focus();
      }
    }

    public focusInput() {
      this.$data.isFocused = true;
    }

    public blurInput() {
      setTimeout(() => {
        this.$data.isFocused = false;
        this.$data.isLabeled = this.$data.inputValue != null && this.$data.inputValue != "";
      }, 300);
    }

    public changeInput() {
      setTimeout(() => {
        if (this.IsDate && this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'TWO-POINT-STUDIOS') {
          let value = "";
          for (var i = 0; i < this.$data.inputValue.length; ++i) {
            if (i == 4) {
              value += '-';
            }
            else if (i == 7) {
              value += '-';
            }
            else if (this.$data.inputValue[i] != '-') {
              value += this.$data.inputValue[i];
            }
          }
          this.$data.inputValue = value;

          const currentDate = moment();
          const regex = new RegExp("^(19[0-9][0-9]|20[01][0-9]|" + currentDate.year() + ")[\-](0?[1-9]|1[012])[\-](0?[1-9]|[12][0-9]|3[01])$", "g");
          const matches = regex.exec(this.$data.inputValue);

          this.$set(this.$data, "hasErrors", false);
          const error = this.$data.errors.find((err: IErrorModel) => err.Property == "Date");
          if (error != null) {
            this.$data.errors.splice(this.$data.errors.indexOf(error), 1);
          }

          if (!matches) {
            this.$set(this.$data, "hasErrors", true);
            this.$data.errors.push({ Property: "Date", ErrorMessage: "Invalid date value" } as IErrorModel);
          }
          else {
            const selectedDate = moment(this.$data.inputValue, "DD/MM/YYYY");
            const dateToCompare = currentDate.subtract(13, 'year');
            const diff = selectedDate.diff(dateToCompare);

            if (diff > 0) {
              this.$set(this.$data, "hasErrors", true);
              this.$data.errors.push({ Property: "Date", ErrorMessage: "You must be at least 13 years old" } as IErrorModel);
            }
          }

          this.$emit('update:input:errors', this.$data.errors);
        }
        else if (this.IsPassword && this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'TWO-POINT-STUDIOS') {
          this.$set(this.$data, "hasErrors", false);
          const error = this.$data.errors.find((err: IErrorModel) => err.Property == "Password");
          if (error != null) {
            this.$data.errors.splice(this.$data.errors.indexOf(error), 1);
          }

          if (this.$data.inputValue.length < 8 || this.$data.inputValue.length > 16 || !/(?=.*[a-z])(?=.*[A-Z])(?=\S+$).{8,16}$/.test(this.$data.inputValue)) {
            this.$set(this.$data, "hasErrors", true);
            this.$data.errors.push({ Property: "Password", ErrorMessage: "Password must be between 8 and 16 characters with at least an upper case and a lower case character" } as IErrorModel);
          }
          this.$emit('update:input:errors', this.$data.errors);
        }
        this.$emit('update:input:value', this.Name, this.$data.inputValue);
      }, 200);
    }

    public keyUp(event: KeyboardEvent) {
      if (!this.IsDate) {
        return;
      }

      const ipLength = this.$data.inputValue.length;
      if ((ipLength === 4 || ipLength === 7) && event.keyCode != 46 && event.keyCode != 8) {
        this.$data.inputValue += '-';
      }
    }
  }
